import { useEffect, useState } from "react";
import Header from "../components/header";
import "./painel.css"
import Icon from '@mdi/react';
import { mdiChevronRight, mdiFileDocumentOutline, mdiCreditCardOutline, mdiAccountOutline, mdiMapMarkerOutline, mdiLockOutline, mdiHelpCircleOutline, mdiHeadset, mdiFileDocument, mdiShieldCheckOutline } from '@mdi/js';
import { Link, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../global";


const GOOGLE_API = 'AIzaSyCRJnBSTStmvD5-WUr03HCQNHJ44N4Nz5g';

const formatarData = (dataStr) => {
    if (!dataStr) return '';
    try {
        const checkFormat = dataStr.trim().split(' ')[0];
        if (checkFormat.includes('/')) {
            const parts = checkFormat.split('/');
            if (parts.length === 3) return `${parts[0].padStart(2, '0')}/${parts[1].padStart(2, '0')}/${parts[2].slice(-2)}`;
        }
        if (checkFormat.includes('-')) {
            const parts = checkFormat.split('-');
            if (parts.length === 3) return `${parts[2].padStart(2, '0')}/${parts[1].padStart(2, '0')}/${parts[0].slice(-2)}`;
        }
    } catch (e) {
        return dataStr;
    }
    return dataStr;
};

export default function Painel({ isAuth, setIsAuth }) {

    const navigate = useNavigate();
    useEffect(() => {
        const verified = localStorage.getItem("verificado");
        const auth = localStorage.getItem("auth");
        if (auth === "false") {
            navigate('/Autenticacao')
        } else if (auth === "true") {
            if (verified === "false") {
                navigate('/EmailVerify')
            }
        }
    }, []);

    const [view, setView] = useState('relatorios');
    const [userData, setUserData] = useState([]);

    const [relatoriosAdquiridos, setRelatoriosAdquiridos] = useState([]);
    const [pagamentosRealizados, setPagamentosRealizados] = useState([]);

    const [cep, setCep] = useState('');
    const [endereco, setEndereco] = useState('');
    const [numero, setNumero] = useState('');
    const [complemento, setComplemento] = useState('');
    const [bairro, setBairro] = useState('');
    const [cidade, setCidade] = useState('');
    const [uf, setUf] = useState('');

    const buscarCep = async (cepDigitado) => {
        const cepLimpo = cepDigitado.replace(/\D/g, '');

        if (cepLimpo.length !== 8) return;

        try {
            const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
            const data = await response.json();

            if (data.erro) {
                console.log('CEP não encontrado');
                return;
            }

            setCep(data.cep || cepLimpo);
            setEndereco(data.logradouro || '');
            setBairro(data.bairro || '');
            setCidade(data.localidade || '');
            setUf(data.uf || '');
        } catch (error) {
            console.error('Erro ao buscar CEP:', error);
        }
    };


    const getData = async () => {
        const response = await fetch(`${API_BASE_URL}/dados-usuario/get_user_data.php`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include",
        });

        const data = await response.json();
        if (data.status === 'success') {
            setUserData(data)
            setCep(data.dados_basicos.cep)
            setEndereco(data.dados_basicos.endereco)
            setNumero(data.dados_basicos.numero)
            setBairro(data.dados_basicos.bairro)
            setComplemento(data.dados_basicos.complemento)
            setCidade(data.dados_basicos.cidade)
            setUf(data.dados_basicos.estado)
        } else {
            console.log(data.msg)
        }
    }


    useEffect(() => { getData(); get_relatorios(); getPagamentos() }, [view])

    const atualizarEndereco = async () => {
        const response = await fetch(`${API_BASE_URL}/dados-usuario/atualizar_endereco.php`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                cep: cep,
                endereco: endereco,
                numero: numero,
                complemento: complemento,
                bairro: bairro,
                cidade: cidade,
                uf: uf
            }),
            credentials: "include",
        });

        const data = await response.json();
        if (data.status === 'success') {

        } else {
            console.log(data.msg)
        }
    }


    const get_relatorios = async () => {
        const response = await fetch(`${API_BASE_URL}/dados-usuario/meus-relatorios.php`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            credentials: 'include'
        })

        const data = await response.json();
        if (data.status === 'success') {
            setRelatoriosAdquiridos(data.relatorios_adquiridos);
        } else {
            console.log(data.msg)
        }
    }

    const getPagamentos = async () => {
        const response = await fetch(`${API_BASE_URL}/dados-usuario/meus-pagamentos.php`, {
            method: 'GET',
            credentials: "include"
        });

        const data = await response.json();
        if (data.status === 'success') {
            setPagamentosRealizados(data.pagamentos_realizados)
        } else {
            console.log(data.msg)
        }
    }

    const [senhaAtual, setSenhaAtual] = useState('')
    const [senhaNova, setSenhaNova] = useState('')
    const [senhaConfirmar, setSenhaConfirmar] = useState('')

    const alterarSenha = async () => {

        if (senhaNova != senhaConfirmar) {
            return alert('Confirme sua nova senha. As senhas não coincidem.')
        }


        const response = await fetch(`${API_BASE_URL}/dados-usuario/alterar-senha.php`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                senhaAtual: senhaAtual,
                senhaNova: senhaNova,
            }),
            credentials: 'include'
        });

        const data = await response.json();
        if (data.status === "success") {
            alert('Senha alterada com sucesso');
        } else {
            alert(data.msg)
        }
    }

    const irParaPrecos = () => {
        navigate("/", { state: { scrollToPlanos: true } });
    };

    const irParaFAQ = () => {
        navigate("/", { state: { scrollToFAQ: true } });
    };

    const consultar = async (relatorio) => {
        let enderecoQuery = `${relatorio.rua},${relatorio.numero},${relatorio.bairro}, ${relatorio.cidade}`
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(enderecoQuery)}&components=country:BR&key=${GOOGLE_API}`;

        try {
            const response = await fetch(url);
            const data = await response.json();

            if (data.status === "OK") {
                const resultado = data.results[0];

                const estadoComp = resultado.address_components.find(c =>
                    c.types.includes("administrative_area_level_1")
                );

                const cepComp = resultado.address_components.find(c =>
                    c.types.includes("postal_code")
                );

                let query = `id=${resultado.place_id}`

                navigate(`/Relatorio?${query}`, { state: { resultado } })

            } else {
                console.error("Erro da API:", data.status);

            }
        } catch (erro) {
            console.error("Erro na requisição:", erro);

        }
    }


    return (
        <div>
            <Header isAuth={isAuth} setIsAuth={setIsAuth} />

            <div className="painel_conteudo">

                <div className="painel_items">
                    <div className="painel_items_group">
                        <h2><span>Atividade</span></h2>
                        <button className={view === 'relatorios' ? 'active' : ''} onClick={() => setView('relatorios')}><Icon path={mdiFileDocumentOutline} size={1} /> <span>Meus relatórios</span></button>
                        <button className={view === 'historicoPagamentos' ? 'active' : ''} onClick={() => setView('historicoPagamentos')}><Icon path={mdiCreditCardOutline} size={1} /> <span>Histórico de pagamentos</span></button>
                    </div>
                    <div className="painel_items_group">
                        <h2><span>Conta</span></h2>
                        <button className={view === 'meusDados' ? 'active' : ''} onClick={() => setView('meusDados')}><Icon path={mdiAccountOutline} size={1} /> <span>Meus dados</span></button>
                        <button className={view === 'endereco' ? 'active' : ''} onClick={() => setView('endereco')}><Icon path={mdiMapMarkerOutline} size={1} /> <span>Endereço</span></button>
                        <button className={view === 'alterarSenha' ? 'active' : ''} onClick={() => setView('alterarSenha')}><Icon path={mdiLockOutline} size={1} /> <span>Alterar senha</span></button>
                    </div>
                    <div className="painel_items_group">
                        <h2><span>Ajuda</span></h2>
                        <button onClick={irParaFAQ} style={{ cursor: 'pointer' }}><Icon path={mdiHelpCircleOutline} size={1} /> <span>FAQ</span></button>
                        <Link className="buttons-nav-menu" to="/FaleConosco"><Icon path={mdiHeadset} size={1} /> <span>Suporte</span></Link>
                        <Link className="buttons-nav-menu" to="/TermosDeUso"><Icon path={mdiFileDocument} size={1} /> <span>Termos de uso</span></Link>
                        <Link className="buttons-nav-menu" to="/PoliticaPrivacidade"><Icon path={mdiShieldCheckOutline} size={1} /> <span>Política de privacidade</span></Link>
                    </div>
                </div>


                {view === 'relatorios' &&
                    <div className="item-content">
                        <div className="painel-content-header">
                            <h1>Meus relatórios</h1>
                            <h2>Veja os endereços já extraídos</h2>
                        </div>

                        <div className="dashboard-card borderless">
                            <div className="meus-relatorios_group">
                                {relatoriosAdquiridos.map((relatorio, index) =>
                                    <button key={index} onClick={() => { consultar(relatorio) }} className="meus-relatorios_group_relatorio">
                                        <div className="nomes">
                                            <h3>{relatorio.rua || "Nome da rua indisponível*"}, {relatorio.numero}</h3>
                                            <p>{(!relatorio.cep || String(relatorio.cep).toLowerCase() === 'undefined') ? 'CEP não identificado' : relatorio.cep}</p>
                                        </div>
                                        <h3>{(!relatorio.bairro || String(relatorio.bairro).toLowerCase() === 'undefined' || relatorio.bairro === relatorio.cidade) ? 'Bairro não identificado' : relatorio.bairro}</h3>
                                        <h3>{relatorio.cidade}</h3>
                                        <p>Adquirido em: {formatarData(relatorio.data_aquisicao)}</p>
                                        <div className="icon-action">
                                            <Icon path={mdiChevronRight} size={1} color={'#fc7b44'} />
                                        </div>
                                    </button>
                                )}

                                {relatoriosAdquiridos.length === 0 && (
                                    <div className="empty-state">
                                        <p>Você ainda não desbloqueou nenhum relatório</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                }

                {view === 'historicoPagamentos' &&
                    <div className="item-content">
                        <div className="painel-content-header">
                            <h1>Histórico de pagamentos</h1>
                            <h2>Acesse informações referentes aos pagamentos realizados</h2>
                        </div>

                        <div className="dashboard-card borderless">
                            <div className="meus-relatorios_group">
                                {pagamentosRealizados.map((pagamento, index) =>
                                    <a key={index} href={`/CompraEfetuada?session_id=${pagamento.stripe_id}`} className="meus-relatorios_group_relatorio">
                                        <div className="nomes">
                                            <h3>{pagamento.produto}</h3>
                                            <p>{pagamento.quantidade} un.</p>
                                        </div>
                                        <h3>R$ {pagamento.valor}</h3>
                                        <p>Adquirido em {pagamento.data_pagamento}</p>
                                        <div className="icon-action">
                                            <Icon path={mdiChevronRight} size={1} color={'#fc7b44'} />
                                        </div>
                                    </a>
                                )}
                            </div>
                        </div>

                    </div>
                }

                {view === 'meusDados' &&
                    <div className="item-content">
                        <div className="painel-content-header">
                            <h1>Meus dados</h1>
                            <h2>Visualize e altere dados de sua conta</h2>
                        </div>

                        <div className="dashboard-card">
                            <div className="meus-dados_group">
                                <div className="inputGroup">
                                    <label>Nome</label>
                                    <input type="text" value={userData.dados_basicos.nome} readOnly></input>
                                </div>
                                <div className="inputGroup">
                                    <label>Sobrenome</label>
                                    <input type="text" value={userData.dados_basicos.sobrenome}></input>
                                </div>
                                <div className="inputGroup">
                                    <label>CPF</label>
                                    <input type="text" value={userData.dados_basicos.cpf} readOnly></input>
                                </div>
                                <div className="inputGroup">
                                    <label>E-mail</label>
                                    <input type="text" value={userData.dados_basicos.email}></input>
                                </div>
                                <button className="save-btn">Salvar</button>
                            </div>
                        </div>
                    </div>
                }

                {view === 'endereco' &&
                    <div className="item-content">
                        <div className="painel-content-header">
                            <h1>Endereço</h1>
                            <h2>Complete dados de sua localização atual</h2>
                        </div>

                        {userData && Object.keys(userData).length > 0 &&
                            <div className="dashboard-card">
                                <div className="meus-dados_group">
                                    <div className="inputGroup full-width">
                                        <label>CEP</label>
                                        <input type="text" value={cep} onChange={(e) => { setCep(e.target.value); if (cep.length === 8) buscarCep(cep) }}></input>
                                    </div>
                                    <div className="inputGroup full-width">
                                        <label>Endereço</label>
                                        <input type="text" value={endereco} onChange={(e) => setEndereco(e.target.value)}></input>
                                    </div>
                                    <div className="inputGroup">
                                        <label>Número</label>
                                        <input type="text" value={numero} onChange={(e) => setNumero(e.target.value)}></input>
                                    </div>
                                    <div className="inputGroup">
                                        <label>Complemento</label>
                                        <input type="text" value={complemento} onChange={(e) => setComplemento(e.target.value)}></input>
                                    </div>
                                    <div className="inputGroup">
                                        <label>Bairro</label>
                                        <input type="text" value={bairro} onChange={(e) => setBairro(e.target.value)}></input>
                                    </div>
                                    <div className="inputGroup">
                                        <label>Cidade</label>
                                        <input type="text" value={cidade} onChange={(e) => setCidade(e.target.value)}></input>
                                    </div>
                                    <div className="inputGroup full-width">
                                        <label>UF</label>
                                        <input type="text" value={uf} onChange={(e) => setUf(e.target.value)}></input>
                                    </div>
                                    <button className="save-btn" onClick={() => atualizarEndereco()}>Salvar</button>
                                </div>
                            </div>
                        }
                    </div>
                }

                {view === 'alterarSenha' &&
                    <div className="item-content">
                        <div className="painel-content-header">
                            <h1>Alterar senha</h1>
                            <h2>Preencha os campos para alterar sua senha</h2>
                        </div>

                        <div className="dashboard-card">
                            <div className="meus-dados_group single-col">
                                <div className="inputGroup">
                                    <label>Senha atual</label>
                                    <input type="password" value={senhaAtual} onChange={(e) => setSenhaAtual(e.target.value)}></input>
                                </div>
                                <div className="inputGroup">
                                    <label>Nova senha</label>
                                    <input type="password" value={senhaNova} onChange={(e) => setSenhaNova(e.target.value)}></input>
                                </div>
                                <div className="inputGroup">
                                    <label>Confirme a nova senha</label>
                                    <input type="password" value={senhaConfirmar} onChange={(e) => setSenhaConfirmar(e.target.value)}></input>
                                </div>
                                <button className="save-btn" onClick={() => { alterarSenha() }}>Salvar</button>
                            </div>
                        </div>
                    </div>
                }



            </div>
        </div>

    )
}